import { tns } from '../../node_modules/tiny-slider/src/tiny-slider'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import BigPicture from 'bigpicture'

export default {
	init() {
		gsap.registerPlugin(ScrollTrigger)
		const $homeSliderWrap = $('#homeSliderWrap')
		if ($homeSliderWrap.length) {
			tns({
				container: '#homeSliderWrap',
				items: 1,
				slideBy: 1,
				autoplay: true,
				mode: 'gallery',
				loop: true,
				// mouseDrag: true,
				nav: true, //dots
				controls: false, //arrows
				// touch: true,
				autoplayButtonOutput: false,
				// autoplayHoverPause: true,
				autoplayTimeout: 2500,
				speed: 5000,
				controlsText: [
					'<span class="sr-only">prev</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M11 26l21 21-5 5L2 28l-2-2 2-3L27 0l5 5-20 18"/></svg>',
					'<span class="sr-only">Next</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M21 26L0 47l5 5 25-24 2-2-2-3L5 0 0 5l20 18"/></svg>',
				],
				responsive: {
					767: {
						nav: false, //dots
						controls: true, //arrows
					},
				},
			})
		}
		const $featMenuSliderWrap = $('#featured_menu')
		if ($featMenuSliderWrap.length) {
			tns({
				container: '#featured_menu',
				items: 1,
				slideBy: 1,
				autoplay: true,
				// mode:"gallery",
				nav: true, //dots
				touch: true,
				mouseDrag: true,
				navPosition: top, //dots
				controls: false, //arrows
				touch: true,
				autoplayButtonOutput: false,
				autoplayHoverPause: true,

				// autoplayTimeout: 7500,
				speed: 1000,
				controlsText: [
					'<span class="sr-only">prev</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M11 26l21 21-5 5L2 28l-2-2 2-3L27 0l5 5-20 18"/></svg>',
					'<span class="sr-only">Next</span><svg viewBox="0 0 32 52"><path fill-rule="evenodd" d="M21 26L0 47l5 5 25-24 2-2-2-3L5 0 0 5l20 18"/></svg>',
				],
				responsive: {
					767: {
						nav: false, //dots
						controls: true, //arrows
					},
				},
			})
		}
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS

		$('h2').each((i, header) => {
			header.innerHTML = header.textContent.replace(
				/\S/g,
				"<span class='letter'>$&</span>"
			)
		})

		// let $h1 = $('h1')[0]
		// let $h1Span = $('h1').find('span')
		// if ($h1Span.length) {
		// 	$h1Span = $h1Span[0]
		// 	$h1.removeChild($h1Span)
		// 	$h1.innerHTML = $h1.textContent.replace(
		// 		/\S/g,
		// 		"<span class='letter'>$&</span>"
		// 	)
		// 	$h1.appendChild($h1Span)
		// }

		// var tlm = new TimelineMax({})
		// gsap.from($('h1 > .letter'), {
		// 	// scrollTrigger: {
		// 	// 	trigger: 'h1 > .letter',
		// 	// },
		// 	opacity: 0,
		// 	rotationY: 90,
		// 	duration: 2,
		// 	delay: 0.5,
		// 	stagger: 0.05,
		// })
		gsap.from($('h1'), {
			opacity: 0,
			x: -10,
			duration: 2,
			delay: 0.25,
		})
		gsap.from($('.home-1 h2 .letter'), {
			scrollTrigger: {
				trigger: '.home-1 h2 .letter',
			},
			opacity: 0,
			rotationY: 90,
			duration: 0.65,
			stagger: 0.1,
		})
		gsap.from(
			$('.home-2 h2 .letter'),
			{
				scrollTrigger: {
					trigger: '.home-2 h2 .letter',
				},
				opacity: 0,
				rotationY: 90,
				duration: 0.65,
				stagger: 0.1,
			},
			'0.1'
		)
		gsap.from(
			$('.home-3 h2 .letter'),
			{
				scrollTrigger: {
					trigger: '.home-3 h2 .letter',
				},
				opacity: 0,
				rotationY: 90,
				duration: 0.65,
				stagger: 0.1,
			},
			'0.1'
		)
		gsap.from(
			$('.home-4 h2 .letter'),
			{
				scrollTrigger: {
					trigger: '.home-4 h2 .letter',
				},
				opacity: 0,
				rotationY: 90,
				duration: 0.65,
				stagger: 0.1,
			},
			'0.1'
		)

		// gsap.from('h1 > .letter', {
		// 	opacity: 0,
		// 	duration: 1,
		// 	stagger: 0.05,
		// 	ease: 'power4.easeOut',
		// })
	},
}
